import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../@shared/dialog/confirm-dialog/confirm-dialog.component';

export interface EditSektionData {
  id: string;
  name: string;
  gebaeudeId: string;
  status?: number;
}

@Component({
  selector: 'app-edit-sektion-dialog',
  templateUrl: './edit-sektion-dialog.component.html',
  styleUrls: ['./edit-sektion-dialog.component.css'],
})
export class EditSektionDialogComponent implements OnInit {
  frmSektion: UntypedFormGroup;
  sektionId: string;
  gebaeudeId: string;
  status: number = 1; // Default to active

  constructor(
    public dialogRef: MatDialogRef<EditSektionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditSektionData,
    private _fb: UntypedFormBuilder,
    private dialog: MatDialog
  ) {
    this.sektionId = data.id;
    this.gebaeudeId = data.gebaeudeId;
    this.status = data.status ?? 1; // Default to active if not provided

    this.frmSektion = this._fb.group({
      name: [data.name, [Validators.required, Validators.minLength(2)]],
      gebaeude_id: [this.gebaeudeId]
    });
  }

  ngOnInit() {
    // Form is already initialized in constructor
  }

  onConfirm(): void {
    if (this.frmSektion.valid) {
      this.dialogRef.close({ 
        event: 'update', 
        data: {
          id: this.sektionId,
          ...this.frmSektion.value
        }
      });
    }
  }

  onDelete(): void {
    const confirmed = confirm('Sind Sie sicher, dass Sie diese Sektion deaktivieren möchten? Sie wird als inaktiv markiert und in der Historie angezeigt.');
    if (confirmed) {
      this.dialogRef.close({ 
        event: 'delete', 
        data: { 
          id: this.sektionId,
          name: this.frmSektion.get('name')?.value || this.data.name
        }
      });
    }
  }

  onDismiss(): void {
    this.dialogRef.close({ event: 'cancel' });
  }

  isInactive(): boolean {
    return this.status === 0;
  }

  onRestore(): void {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: new ConfirmDialogModel(
        'Sektion wiederherstellen',
        'Soll die Sektion wiederhergestellt werden?',
        'Abbrechen',
        'Wiederherstellen'
      )
    });

    confirmDialog.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.dialogRef.close({
          event: 'restore',
          data: {
            id: this.sektionId,
            status: 1
          }
        });
      }
    });
  }
}

